export const reviewEndpoints = {
    product: {
        list: {
            api: '/api/reviews/product',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/reviews/product/details',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/api/reviews/product',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/reviews/product/edit',
            method: 'POST',
            parameter: false
        },
        reject: {
            api: '/api/reviews/product/reject',
            method: 'POST',
            parameter: false
        },
        approve: {
            api: '/api/reviews/product/approve',
            method: 'POST',
            parameter: false
        },
        reassign: {
            api: '/api/reviews/product/reassign',
            method: 'POST',
            parameter: false
        }
    },
    dictionary : {
        attribute: {
            api: '/api/reviews/configuration/dictionary',
            method: 'GET',
            parameter: true
        }
    }
};



// WEBPACK FOOTER //
// ./src/endpoints/review.endpoints.ts